import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuUpdateSource = new Subject<void>();
  menuUpdate$ = this.menuUpdateSource.asObservable();

  updateMenu() {
    this.menuUpdateSource.next();
  }
}